import {SHOW_WELCOME_DIALOG} from '@/store/actions/welcome_dialog'

const getters = {
  getWelcomeDialog: state => state.showWelcomeDialog,
};

const state = {
    showWelcomeDialog: localStorage.getItem('showWelcomeDialog')?JSON.parse(localStorage.getItem('showWelcomeDialog')):true
};

const mutations = {
    [SHOW_WELCOME_DIALOG]: (state, payload) => {
    	state.showWelcomeDialog = payload;
    	localStorage.setItem('showWelcomeDialog', payload)
    }
};

const actions = {
    [SHOW_WELCOME_DIALOG]: ({commit}, payload) => commit(SHOW_WELCOME_DIALOG, payload)
};

export default {
    state,
    mutations,
    actions,
    getters
}